import React from "react";
import "./WantAdTableSkeleton.scss";

const COLUMNS = [
  { key: "date", width: "10%" },
  { key: "title", width: "22%" },
  { key: "location", width: "18%" },
  { key: "status", width: "12%", pill: true },
  { key: "matches", width: "14%", pill: true },
  { key: "intros", width: "10%" },
  { key: "client", width: "14%" },
];

const WantAdTableSkeleton = ({ rows = 5 }) => (
  <div
    className="wantad-table-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="visually-hidden">Loading your Want-Listings</span>

    <div className="wantad-table-skeleton__row wantad-table-skeleton__row--head">
      {COLUMNS.map((col) => (
        <div
          className="wantad-table-skeleton__cell"
          key={col.key}
          style={{ width: col.width }}
        >
          <div className="wantad-table-skeleton__head-line shimmer" />
        </div>
      ))}
    </div>

    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div className="wantad-table-skeleton__row" key={rowIndex}>
        {COLUMNS.map((col) => (
          <div
            className="wantad-table-skeleton__cell"
            key={col.key}
            style={{ width: col.width }}
          >
            <div
              className={
                col.pill
                  ? "wantad-table-skeleton__pill shimmer"
                  : "wantad-table-skeleton__line shimmer"
              }
            />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default WantAdTableSkeleton;
